import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GroupListing, TagAmendment } from './Pages';

export const TagAmendmentRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={TagAmendment} />
    </Fragment>
)